import { CardFormElementOptions, CheckoutSdkOptions, CheckoutSdkType } from '@mangopay/checkout-sdk-react-elements';
import { CheckoutSdkInstance } from '../checkout-sdk-instance';
import { AppEventsDispatcher } from '../proxy';
import { env } from '../env';

const hostedCheckoutSdkUrl = env.frameUrl;

export class CheckoutSdk {
  static loadCheckoutSdk = (
    elementOrSelector: HTMLElement | string,
    options: CheckoutSdkOptions
  ): Promise<CheckoutSdkInstance> => {
    if (!options?.paymentMethods?.length) {
      throw new Error('At least one payment method is required in options.paymentMethods');
    }

    return new Promise<CheckoutSdkInstance>((resolve) => {
      const sdk = new AppEventsDispatcher(options, hostedCheckoutSdkUrl, window.origin, CheckoutSdkType.Checkout);
      sdk.on('initialize', () => resolve(sdk));
      sdk.mount(elementOrSelector);
    });
  };

  static loadCardFormElement = (
    elementOrSelector: HTMLElement | string,
    options: CardFormElementOptions
  ): Promise<CheckoutSdkInstance> => {
    const { paymentMethod, ...restOptions } = options;
    if (!paymentMethod) {
      throw new Error('Card payment method is required in options.paymentMethod');
    }
    return new Promise<CheckoutSdkInstance>((resolve) => {
      const sdkOptions = { ...restOptions, paymentMethods: [paymentMethod] } as CheckoutSdkOptions;
      const sdk = new AppEventsDispatcher(sdkOptions, hostedCheckoutSdkUrl, window.origin, CheckoutSdkType.CardForm);
      sdk.on('initialize', () => resolve(sdk));
      sdk.mount(elementOrSelector);
    });
  };
}
